import { atom } from 'jotai';

export const openSyncConfigurationModalAtom = atom(false);
